<template>
  <VNavigationDrawer
    :value="$vuetify.breakpoint.mdAndUp || $store.state.ui.drawer"
    :mini-variant="$vuetify.breakpoint.smAndDown ? false : !$store.state.ui.drawer"
    :mobile-break-point="$vuetify.breakpoint.thresholds.sm"
    app
    class="navigation-drawer"
    @update:mini-variant="$store.commit('ui/setDrawer', { value: $event })"
    @input="$vuetify.breakpoint.smAndDown ? $store.commit('ui/setDrawer', { value: $event }) : null"
  >
    <template #prepend>
      <VMenu
        right
        offset-x
        :disabled="!currentUser && authorized"
      >
        <template #activator="{ on: menuOn }">
          <VListItem
            :two-line="!!currentUser"
            dense
            v-on="menuOn"
          >
            <template v-if="currentUser">
              <VListItemAvatar
                color="green"
                min-width="32"
                width="32"
                height="32"
              >
                <strong class="white--text">
                  {{ $store.getters['user/initials'](currentUser.id) }}
                </strong>
              </VListItemAvatar>
              <VListItemContent>
                <VListItemTitle>
                  {{ $store.getters['user/displayName'](currentUser.id) }}
                </VListItemTitle>
                <VListItemSubtitle>
                  {{ $store.state.company.current.name }}
                </VListItemSubtitle>
              </VListItemContent>
            </template>
            <template v-else-if="authorized">
              <VListItemAvatar><VIcon>mdi-progress-clock</VIcon></VListItemAvatar>
              <VListItemContent>
                <VListItemSubtitle><i>Авторизация...</i></VListItemSubtitle>
              </VListItemContent>
            </template>
            <template v-else>
              <VListItemAvatar><VIcon>mdi-account</VIcon></VListItemAvatar>
              <VListItemContent>
                <VListItemAction>Авторизоваться</VListItemAction>
              </VListItemContent>
            </template>
          </VListItem>
        </template>
        <VList>
          <template v-if="currentUser">
            <VListItem
              :to="{ name: 'user', params: { userId: currentUser.id } }"
              exact
              v-text="'Мой профиль'"
            />
            <VListItem
              @click="$store.dispatch('auth/completeLogOut')"
              v-text="'Выйти'"
            />
          </template>
          <template v-else>
            <VListItem
              @click="$store.commit('ui/setLoginModal', { value: true })"
              v-text="'Войти'"
            />
            <VListItem
              @click="$store.commit('ui/setRegisterModal', { value: true })"
              v-text="'Регистрация'"
            />
          </template>
        </VList>
      </VMenu>
    </template>
    <VDivider />

    <VList dense>
      <template v-if="authorized">
        <!--<WorkTimeDrawerItem />-->
        <VDivider />
      </template>

      <VListItem
        link
        to="/"
        title="Главная"
      >
        <VListItemAction>
          <VIcon>mdi-home</VIcon>
        </VListItemAction>
        <VListItemContent>
          <VListItemTitle class="text-left">
            Главная
          </VListItemTitle>
        </VListItemContent>
      </VListItem>
      <VListItem
        link
        :to="{ name: 'userChart' }"
        title="События пользователей"
      >
        <VListItemAction>
          <VIcon>mdi-account-details</VIcon>
        </VListItemAction>
        <VListItemContent>
          <VListItemTitle class="text-left">
            События пользователей
          </VListItemTitle>
        </VListItemContent>
      </VListItem>
      <VListItem
        v-if="currentUser"
        link
        :to="{ name: 'feed' }"
        title="Лента событий"
      >
        <VListItemAction>
          <VIcon>mdi-post</VIcon>
        </VListItemAction>
        <VListItemContent>
          <VListItemTitle class="text-left">
            Лента
          </VListItemTitle>
        </VListItemContent>
      </VListItem>
      <VListItem
        v-if="currentUser"
        link
        :to="{ name: 'users' }"
        title="Пользователи"
      >
        <VListItemAction>
          <VIcon>mdi-account-multiple</VIcon>
        </VListItemAction>
        <VListItemContent>
          <VListItemTitle class="text-left">
            Пользователи
          </VListItemTitle>
        </VListItemContent>
      </VListItem>
      <VListItem
        link
        :to="{ name: 'chart' }"
        title="Диаграмма событий"
      >
        <VListItemAction>
          <VIcon>mdi-chart-timeline-variant</VIcon>
        </VListItemAction>
        <VListItemContent>
          <VListItemTitle class="text-left">
            Все события
          </VListItemTitle>
        </VListItemContent>
      </VListItem>
      <VListItem
        link
        :to="{ name: 'about' }"
        title="Помощь"
      >
        <VListItemAction>
          <VIcon>mdi-help-circle</VIcon>
        </VListItemAction>
        <VListItemContent>
          <VListItemTitle class="text-left">
            Помощь
          </VListItemTitle>
        </VListItemContent>
      </VListItem>
      <VListItem
        link
        :to="{ name: 'integrations' }"
        title="Интеграция"
      >
        <VListItemAction>
          <VIcon>mdi-graph</VIcon>
        </VListItemAction>
        <VListItemContent>
          <VListItemTitle class="text-left">
            Интеграция
          </VListItemTitle>
        </VListItemContent>
      </VListItem>
      <VListItem
        v-if="currentUser && currentUser.isAdmin"
        link
        :to="{ name: 'settings' }"
        title="Настройки"
      >
        <VListItemAction>
          <VIcon>mdi-cogs</VIcon>
        </VListItemAction>
        <VListItemContent>
          <VListItemTitle class="text-left">
            Настройки
          </VListItemTitle>
        </VListItemContent>
      </VListItem>
      <VListItem
        link
        :to="{ name: 'contacts' }"
        title="Контакты"
      >
        <VListItemAction>
          <VIcon>mdi-message-text</VIcon>
        </VListItemAction>
        <VListItemContent>
          <VListItemTitle class="text-left">
            Обратная связь
          </VListItemTitle>
        </VListItemContent>
      </VListItem>
    </VList>
  </VNavigationDrawer>
</template>

<script>
// import WorkTimeDrawerItem from './WorkTimeDrawerItem'
export default {
  components: {
    // WorkTimeDrawerItem,
  },
  props: {
    value: { type: Boolean, default: true },
  },
  computed: {
    currentUser() { return this.$store.state.user.current },
    authorized() { return !!this.$store.state.auth.token },
  },
  methods: {
    closeDrawer() {
      this.$emit('input', false)
    },
  },
}
</script>
